import { Injectable } from '@angular/core';
import { Response, RequestOptionsArgs, Headers, Http, Connection, RequestOptions } from '@angular/http';

import { API_ENDPOINTS } from '../../shared/configuration/api-endpoints';

import { StorageService } from '../../shared/services/storage.service';
import { PopupService } from '../../shared/services/pop-up.service';
import { ErrorService } from '../../shared/services/error.service';
import { HistoryService } from 'app/history/services/history.service';

@Injectable()
export class PlantMapAdminService {

    vTotalData: number = 0;
    vLoadingStatus: boolean;

    vPlantmapLists: Array<{
        plant_record_id: number,
        plant_request_id: string,
        create_date: string,
        updated_date: string,
        project_title: string,
        location: string,
        restricted_area: number,
        status: string,
        registration_type: string
    }>;

    vPlantMapDetail: {
        plant_request_id: string,
        plant_record_id: number,
        project_title: string,
        location: string,
        main_contractor: string,
        restricted_area: number,
        a2_amount: number,
        trans_amount: string,
        trans_method: string,
        payment_received_date: string,
        printed_date: string,
        expiry_date: string,
        status: string,
        attachment: {},
        payment: number,
        email: string //Kowsalya
    }

    vPlantmapStatus: Array<{
        status: string,
        description: string
    }>

    constructor(
        private _http: Http,
        private _errorService: ErrorService,
        private _storageService: StorageService,
        private _popupService: PopupService,
        private _historyService: HistoryService,
    ) {
        this.resetPlantMapDetail();
        this.vLoadingStatus = false;
    }

    getTotalData() {
        return this.vTotalData;
    }

    getPlantmapsList() {
        console.log("Line 644", this.vPlantmapLists);
        return this.vPlantmapLists;
    }

    getAllPlantStatus() {
        return this.vPlantmapStatus;
    }

    getPlantMapDetailData() {
        return this.vPlantMapDetail;
    }

    isLoading() {
        return this.vLoadingStatus;
    }

    resetError() {
        this._errorService.resetErrorFlag();
        this._errorService.resetError();
        this._errorService.resetBackEndError();
    }

    resetPlantMapDetail() {
        this.vPlantMapDetail = {
            plant_request_id: '',
            plant_record_id: 0,
            project_title: '',
            location: '',
            main_contractor: '',
            restricted_area: 0,
            a2_amount: 0,
            trans_amount: '',
            trans_method: '',
            payment_received_date: '',
            printed_date: '',
            expiry_date: '',
            status: '',
            attachment: {},
            payment: 0,
            email: '' //Kowsalya
        }
    }

    loadAllPlantStatus() {
        let data = this._storageService.getSessionItem('allPlantAdminStatus');
        if (data !== null) {
            this.vPlantmapStatus = JSON.parse(data);
        } else {
            this._http.get(API_ENDPOINTS.PLANT_MAP_ADMIN.GET_ALL_STATUS).subscribe(
                (response) => {
                    this.vLoadingStatus = false;
                    let vResponseData: any = response;
                    console.log(vResponseData);
                    this.vPlantmapStatus = vResponseData.data.status;
                    this._storageService.setSessionItem('allPlantAdminStatus', JSON.stringify(this.vPlantmapStatus));
                },
                (error) => {
                    this.vLoadingStatus = false;
                    console.log(error);
                    let vErrorData = error;
                    this._errorService.setErrorFlag(true);
                    this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                }
            );
        }
    }

    loadPlantMaps(pPageNumber, pPageSize, pSearchBy, pFilterBy, pPlantStatus, pSortorder) {
        //this.vLoadingStatus = true;
        var promise = this._http.get(API_ENDPOINTS.PLANT_MAP_ADMIN.GET_PLAD_PLANTMAP + '?page_number=' + pPageNumber + '&page_size=' + pPageSize + '&search_by=' + pSearchBy + '&filter_by=' + pFilterBy + '&status=' + pPlantStatus + '&sortorder=' + pSortorder);

        let p = new Promise((resolve, reject) => {
            promise.subscribe(
                response => {
                    //this.vLoadingStatus = false;
                    let vResponseData: any = response;
                    console.log(vResponseData);
                    this.vPlantmapLists = vResponseData.data.plantmaps;
                    resolve();
                },
                error => {
                    //this.vLoadingStatus = false;
                    console.log(error);
                    let vErrorData = error;
                    this._errorService.setErrorFlag(true);
                    this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                    reject();
                });
        });
        console.log("Line 150", this.vPlantmapLists);
        return p;
    }

    loadTotalData(pSearchBy, pFilterBy, pPlantStatus) {
        var promise = this._http.get(API_ENDPOINTS.PLANT_MAP_ADMIN.GET_PLAD_TOTAL_PLANTMAP + '?search_by=' + pSearchBy + '&filter_by=' + pFilterBy + '&status=' + pPlantStatus);

        let p = new Promise((resolve, reject) => {
            promise.subscribe(
                response => {

                    let vResponseData: any = response;
                    console.log(vResponseData);
                    this.vTotalData = vResponseData.data.total_plantmap;
                    resolve();
                },
                error => {
                    console.log(error);
                    let vErrorData = error;
                    this._errorService.setErrorFlag(true);
                    this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                    reject();
                });
        });
        return p;
    }

    //Kowsalya
    loadAvailablePlantMaps(pPageNumber, pPageSize, pSearchBy, pFromDateFilterBy, pToDateFilterBy, pPlantStatus, pSortorder) {
        console.log("Line 178", pPageNumber, pPageSize, pSearchBy, pFromDateFilterBy, pToDateFilterBy, pPlantStatus);

        var promise = this._http.get(API_ENDPOINTS.PLANT_MAP.
            GET_PLAD_PLANTMAP_DATE + '?page_number=' + pPageNumber +
            '&page_size=' + pPageSize + '&search_by=' + pSearchBy +
            '&fromdatefilter_by=' + pFromDateFilterBy + '&todatefilter_by=' + pToDateFilterBy +
            '&status=' + pPlantStatus +
            '&sortorder=' + pSortorder);


        let p = new Promise((resolve, reject) => {
            promise.subscribe(
                response => {
                    let vResponseData: any = response;
                    console.log(vResponseData);
                    this.vPlantmapLists = vResponseData.data.plantmaps;
                    resolve();
                },
                error => {
                    ;
                    console.log(error);
                    let vErrorData = error;
                    this._errorService.setErrorFlag(true);
                    this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                    reject();
                });
        });
        return p;
    }

    loadTotalDatadate(pSearchBy, pFromDateFilterBy, pToDateFilterBy, pPlantStatus) {

        console.log("Line 201", pSearchBy, pFromDateFilterBy, pToDateFilterBy, pPlantStatus);
        var promise = this._http.get(API_ENDPOINTS.PLANT_MAP.GET_PLAD_PLANTMAP_TOTAL_DATE + '?search_by=' + pSearchBy + '&fromdatefilter_by=' + pFromDateFilterBy + '&todatefilter_by=' + pToDateFilterBy + '&status=' + pPlantStatus);
        let p = new Promise((resolve, reject) => {
            promise.subscribe(
                response => {

                    let vResponseData: any = response;
                    console.log(vResponseData);
                    this.vTotalData = vResponseData.data.total_plantmap;
                    resolve();
                },
                error => {
                    console.log(error);
                    let vErrorData = error;
                    this._errorService.setErrorFlag(true);
                    this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                    reject();
                });
        });
        return p;
    } //Kowsalya

    loadDetailPlantMap(pPlantMapID) {
        this.vLoadingStatus = true;
        var promise = this._http.get(API_ENDPOINTS.PLANT_MAP_ADMIN.GET_DETAIL_PLANTMAP + '?plant_record_id=' + pPlantMapID);

        this.vLoadingStatus = true;

        let p = new Promise((resolve, reject) => {
            promise.subscribe(
                (response) => {
                    this.vLoadingStatus = false;
                    let vResponseData: any = response;
                    console.log(vResponseData);
                    this.vPlantMapDetail = vResponseData.data.plantmaps;
                    resolve();
                },
                (error) => {
                    this.vLoadingStatus = false;
                    console.log(error);
                    let vErrorData = error;
                    this._errorService.setErrorFlag(true);
                    this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                    reject();
                });
        });
        return p;
    }

    printPlantmap() {
        let plant_request_id = this.vPlantMapDetail.plant_request_id;
        if (plant_request_id) {
            let fileName = `PRP_${plant_request_id}.zip`;
            this._historyService.downloadZipFileFromDMS(fileName);
        } else {
            console.error('Plant request ID not found.');
        }
        // let xData = {
        //     plant_record_id : this.vPlantMapDetail.plant_record_id
        // }
        // var promise = this._http.post(API_ENDPOINTS.PLANT_MAP_ADMIN.PRINT_MAP, xData);

        // this.vLoadingStatus = true;

        // let p = new Promise((resolve, reject) => {
        //     promise.subscribe(
        //         (response) => {
        //             this.vLoadingStatus = false;
        //             let vResponseData:any = response;
        //             console.log(vResponseData);
        //             resolve();
        //         },
        //         (error)  => {
        //             this.vLoadingStatus = false;
        //             console.log(error);
        //             let vErrorData = error;
        //             this._errorService.setErrorFlag(true);
        //             this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
        //             reject();
        //         });
        //     });
        // return p;
    }

    reprintPlantmap() {
        let xData = {
            plant_record_id: this.vPlantMapDetail.plant_record_id,
        };
        this.vLoadingStatus = true;
        var promise = this._http.post(API_ENDPOINTS.PLANT_MAP_ADMIN.REPRINT_MAP, xData);

        let p = new Promise((resolve, reject) => {
            promise.subscribe(
                (response) => {
                    this.vLoadingStatus = false;
                    let vResponseData = response;
                    console.log(vResponseData);
                    resolve();
                },
                (error) => {
                    this.vLoadingStatus = false;
                    console.log(error);
                    let vErrorData = error;
                    this._errorService.setErrorFlag(true);
                    this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                    reject();
                }
            );
        });
        return p;
    }

}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/plantmap-admin/services/plant-map-admin.service.ts